import { Filter, FilterConfig } from 'src/utils/composeFilter.ts';
import { QueryParams } from 'src/actuators/user-input/calculations/constants.ts';
import { RegionsEnum } from 'src/generated/operations.ts';
import { initInputState } from 'src/actuators/user-input/InitInputState.ts';
import { initialState, UserInput } from 'src/actuators/user-input/types.ts';

export const parseParam = (value: string): string[] => {
    try {
        const val = JSON.parse(value);
        if (Array.isArray(val) && val.length > 0) {
            return val;
        }
        return [];
    } catch {
        return [];
    }
};

export function useReadUserInput(
    searchParams: URLSearchParams,
    currentRegion: RegionsEnum,
): { config: FilterConfig; filter: Filter; state: UserInput } {
    const state = initInputState(searchParams, initialState);

    const labels = parseParam(searchParams.get(QueryParams.labels) ?? '[]');
    if (labels.length > 0) {
        return {
            config: [['label', 'label']],
            filter: { label: labels },
            state,
        };
    }

    const torques = parseParam(searchParams.get(QueryParams.torques) ?? '[]');
    if (torques.length > 0) {
        return {
            config: [['torques', currentRegion === RegionsEnum.Am ? '65' : '260']],
            filter: { torques },
            state,
        };
    }
    const forces = parseParam(searchParams.get(QueryParams.forces) ?? '[]');
    if (forces.length > 0) {
        return {
            config: [['forces', currentRegion === RegionsEnum.Am ? '223' : '118']],
            filter: { forces },
            state,
        };
    }
    return { config: [], filter: {}, state };
}
